exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list {\n  color: rgba(119, 119, 119, 0.7);\n  font-size: 12px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Projects/dod/companyintroduction/src/app/szechenyi2020/szechenyi2020.component.scss
// module id = ../../../../../src/app/szechenyi2020/szechenyi2020.component.scss
// module chunks = main